export default {
  'fa4bb98e-a314-4389-b7c1-75f41eac2595': 'demo_rs',
  'b6f8cc44-3458-492b-8690-2f7d70134cbb': 'demo_ro',
  '86afd4cc-c0ab-4745-bf04-e8e7f10839f6': 'livebet_1x2_ro',
  'fb68cb4c-0002-42fb-abc3-1cdd7aea0356': 'superbet_ro',
  'b6033433-165d-45b8-9350-b516644a79ba': 'casa',
  'b99752b3-443c-4c80-b559-945a95c4b805': 'nsoft',
  'f0a2c9ff-cbf7-417e-b9ec-867c27bbe9ca': 'expo',
};
